import { Link } from "react-router-dom";
import React from "react";
import { formattedPrice } from "../utils";
import { formatCoffeeType, formatSizeLabel } from "../utils/cellRenderTable";

const CheckoutProductItem = ({ item }) => {
  const unitPrice = item?.discount ? item?.discountPrice : item?.price;
  return (
    <div className="checkout-information-list-item">
      <div className="checkout-information-list-item-image">
        <Link to={`/product/${item?.productId}`}>
          <div className="checkout-information-list-item-qty">
            {item?.quantity}
          </div>
          <img src={item?.image} alt="Fuka" />
        </Link>
      </div>
      <div className="checkout-information-list-item-text">
        <Link to={`/product/${item?.productId}`}>
          <h5>{item?.name}</h5>

          {item?.productType == "COFFEE" && item?.size && (
            <div className="checkout-information-list-item-size">
              Size: <b>{formatSizeLabel(item?.size)}</b>
            </div>
          )}
          {item?.productType == "COFFEE" && item?.coffeeType && (
            <div className="checkout-information-list-item-size">
              Grind level: <b>{formatCoffeeType(item?.coffeeType)}</b>
            </div>
          )}
          <div className="checkout-information-list-item-price-grinding">
            <div className="checkout-information-list-item-grinding">
              {item?.frying ||
                (item?.frying == "-" && (
                  <>
                    Roast: <b>{item?.frying}</b>
                  </>
                ))}
            </div>
            <div className="checkout-information-list-item-price">
              {formattedPrice(unitPrice * item?.quantity)} <small>RSD</small>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default CheckoutProductItem;
